// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3B4cK","footer__row":"footer-module--footer__row--2vPm9","footer__social":"footer-module--footer__social--2cCIz"};